export enum ArgType {
    DOWNLOAD = 'download',
}